export default __webpack_public_path__ + "static/media/itemCombo1.f75dc418.png";